import { useState, useEffect } from 'react'

const useRoleManagement = () => {
    const [allRoles, setAllRoles] = useState([])
    const [roleGroups, setRoleGroups] = useState([])

    useEffect(() => {
        // Fetch roles
        fetch('/v0/roles', { credentials: 'same-origin' })
            .then(response => response.json())
            .then(json => {
                let roles = json.results
                setAllRoles(roles)
            })

        // Fetch role groups
        fetch('/v0/role_groups', { credentials: 'same-origin' })
            .then(response => response.json())
            .then(json => setRoleGroups(json.results))
    }, [])

    const handleRoleGroup = (group, role) => {
        setAllRoles(prevRoles => {
            // First clear all roles in the group
            const clearedRoles = prevRoles.map(d => ({
                ...d,
                checked: d.role_group_id === group.id ? false : d.checked
            }))
            
            // Then set the selected role if provided
            if (role) {
                return clearedRoles.map(d => ({
                    ...d,
                    checked: d.id === role.id ? !d.checked : d.checked
                }))
            }
            
            return clearedRoles
        })
    }

    const hasRole = (role) => {
        return allRoles?.some(d => d.id === role.id && d.checked) || false
    }

    return {
        allRoles,
        setAllRoles,
        roleGroups,
        setRoleGroups,
        handleRoleGroup,
        hasRole
    }
}

export default useRoleManagement
